import React from "react";
import { FieldProps } from "../Datagrid/Field/types";

interface Props {
    record: unknown;
    className?: string;
    field: React.ReactElement<FieldProps>;
}

const ListItemColumn: React.FC<Props> = ({ record, field, className }) => {
    return (
        <div className={className}>
            {React.cloneElement(field, {
                record,
            })}
        </div>
    );
};

export default ListItemColumn;
